import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";

// Capture the prerendered blog article body before createRoot() clears #root, so
// BlogPost can render it as initial content (no async gap → no CLS, LCP holds).
const rootEl = document.getElementById("root")!;
const prerenderedBody = rootEl.querySelector("article.prose")?.innerHTML;
if (prerenderedBody) {
  (window as unknown as { __BLOG_BODY_HTML__?: string }).__BLOG_BODY_HTML__ = prerenderedBody;
}

createRoot(rootEl).render(
  <Suspense fallback={<div className="min-h-screen bg-background" />}>
    <App />
  </Suspense>
);
